import StringUtil from 'utils/string-util'

const TableUtil = {
  getRowValueByAccessor: (row, accessor) => {
    const accessors = accessor.split('.')
    let cellValue   = row[ accessors[ 0 ] ]

    accessors.forEach((key, index) => {
      if (index !== 0) {
        if (cellValue === null) return null
        cellValue = cellValue[ key ]
      }
    })
    // in case value is not string we need to convert it first before humanize it
    if (cellValue !== null)
      cellValue = cellValue.toString()
    return StringUtil.humanize(cellValue)
  },

  convertHistoryDetailIntoTableData: (history) => {
    if(!history){
      return []
    }
    const before = history.before ?? {}
    const after = history.after ?? {}
    const allKeys = new Set([...Object.keys(before), ...Object.keys(after)])

    // Sort function: prioritize "id", then alphabetically by dot-separated segments
    function fieldSorter(a, b) {
      if (a === 'id') return -1
      if (b === 'id') return 1

      const aParts = a.split('.')
      const bParts = b.split('.')

      // ✅ Fields with no dot come before fields with dot
      const aHasDot = aParts.length > 1
      const bHasDot = bParts.length > 1
      if (aHasDot && !bHasDot) return 1
      if (!aHasDot && bHasDot) return -1

      // ✅ Compare each segment alphabetically
      const len = Math.max(aParts.length, bParts.length)
      for (let i = 0; i < len; i++) {
        const aPart = aParts[i] || ''
        const bPart = bParts[i] || ''
        if (aPart !== bPart) return aPart.localeCompare(bPart)
      }

      return 0
    }

    const result = Array.from(allKeys)
      .sort(fieldSorter)
      .map(key => {
        const beforeStr = JSON.stringify(before[key])
        const afterStr = JSON.stringify(after[key])
        const sameValue = (beforeStr === afterStr)
        return {
          fieldName: key,
          before: beforeStr,
          after: afterStr,
          sameValue,
        }
      })

    return result
  }
}

export default TableUtil